// packages/components/src/showcase/FAQSimple.tsx
import React, { useState } from 'react';
import { Card, Button } from '@dopomogai/ui';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

export type FAQItem = { q: string; a: string };

type Props = {
  title?: string;
  items: FAQItem[];
  defaultOpenIndex?: number | null; // open a single item by default; null = all closed
  className?: string;
};

export function FAQSimple({ title = 'Frequently asked questions', items, defaultOpenIndex = null, className }: Props) {
  if (!items || items.length === 0) return null;
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpenIndex);

  return (
    <Card className={className} title={title} icon={<HelpCircle size={22} className="text-slate-600" />}>
      <div className="divide-y-2 divide-slate-200">
        {items.map((it, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={`faq-${i}`} className="py-3">
              <button
                className="w-full flex items-center justify-between text-left"
                onClick={() => setOpenIndex(isOpen ? null : i)}
                aria-expanded={isOpen}
                aria-controls={`faq-panel-${i}`}
              >
                <span className="font-semibold text-slate-800">{it.q}</span>
                {isOpen ? <ChevronUp size={18} className="text-slate-400" /> : <ChevronDown size={18} className="text-slate-400" />}
              </button>
              <div
                id={`faq-panel-${i}`}
                hidden={!isOpen}
                className="mt-2 bg-slate-50 border-2 border-black rounded-lg p-3 text-sm text-slate-700"
              >
                {it.a}
              </div>
            </div>
          );
        })}
      </div>

      <div className="pt-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setOpenIndex(null)}
          className="text-slate-500 hover:text-slate-700"
        >
          Collapse all
        </Button>
      </div>
    </Card>
  );
}

export default FAQSimple;
